import { T } from '@tribeplatform/react-components/i18n'

import type { TableCounterProps } from './types.js'

export const EventsCounter = ({
  matchedCount,
  totalCount,
}: TableCounterProps) => {
  return (
    <div className="flex items-center space-s-1">
      {totalCount === matchedCount ? (
        <span className="font-medium">
          <T
            defaultMessage="{events_count, plural, =0 {No events} =1 {# event} other {# events}}"
            id="Generics.Events.Plural"
            values={{
              events_count: totalCount,
            }}
          />
        </span>
      ) : (
        <span>
          <T
            defaultMessage="<bold>{matched_count, plural, one {# event} other {# events}} matched</bold> of {total_count, number}"
            id="Admin.EventsList.TableCounter"
            values={{
              matched_count: matchedCount,
              total_count: totalCount,
              bold: chunks => <span className="font-medium">{chunks}</span>,
            }}
          />
        </span>
      )}
    </div>
  )
}
